import axios from "axios";
import * as actionType from "../../constant/actionType";
export const GetAllComplianceOfClientList = (ApiData) => {
  return (dispatch) => {
    const config = {
      method: "get",
      url: `${actionType.environment_url}/api/admin/provider/GetAllComplianceOfClientList`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      params: ApiData,
    };
    
    return axios(config)
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        return error;
      });
  };
};
